// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3qNe1","col":"CardReaderDesc_col__3VfRy","label":"CardReaderDesc_label__oS8N5"};